
export function getUrlParameter(name) {
  name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  const regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
  const { location } = window;
  const results = regex.exec(location.search);
  return results === null
    ? ''
    : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

export const isEmailValid = (email) => {
  const emailPattern = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
  return emailPattern.test(email);
};

export const getExtension = (path) => {
  const fullFileName = path.substring(path.lastIndexOf('/') + 1);
  return fullFileName
    .substring(fullFileName.lastIndexOf('.') + 1)
    .toLowerCase();
};

export const today = new Date().toISOString().slice(0, 10);

export const ESCAPE_KEY = 27;
export const ENTER_KEY = 13;

export const PHONE_PATTERN = '[6-9]{1}[0-9]{9}';
export const PHONE_NUM_LENGTH = 10;

export const removeEmptyEntries = (obj) => Object.entries(obj)
    .reduce(
      (acc, [key, value]) => ({
          ...acc,
          ...((!(obj[key] === null || obj[key] === undefined)) && { [key]: value }),
        }),
      {},
    );



export const mapBEKeysToReduxKeys = {
  experience_years_min: 'min_experience',
  experience_years_max: 'max_experience',
  last_contacted_on_min: 'last_contacted_on_min',
  last_contacted_on_max: 'last_contacted_on_max',
  title: 'title',
  designation: 'designation',
  job_code: 'job_code',
  country: 'country_name',
  // searchConfigs: 'searchConfigs',
};

const createSkillsArr = (obj, priority, key) => obj[key]?.map(
    (val, index) => ({
        skill_group_id: index + 1,
        priority,
        // skill: val.reduce((acc, _) => acc.length > 0 ? acc + ' or ' + _ : _, ''),
        skill: val.join(' or '),
      }),
  );

// creating form object for redux store using the query object of network call
export const getFormData = (beStructure) => {
  const formData = Object.entries(beStructure).reduce((formData, [key, value]) => {
    if (value) {
      if (['experience_years_min', 'experience_years_max', 'last_contacted_on_max', 'last_contacted_on_min'].includes(key)) {
        formData[mapBEKeysToReduxKeys[key]] = parseInt(value, 10);
      } else {
        formData[mapBEKeysToReduxKeys[key]] = value;
      }
    }
    return formData;
  }, {});

  // merging must have and nice to have skills in job_skills for use in redux store
  const skills = ['must_have_skills', 'nice_to_have_skills'];
  let job_skills = [];
  skills.forEach((val) => {
    if (beStructure[val]) {
      job_skills = [...job_skills, ...createSkillsArr(beStructure, val === ('must_have_skills' || 'nice_to_have_skills'), val)];
    }
  });
  formData.job_skills = job_skills;

  // creating job_qualificaiton from degree, institute & specialization
  formData.job_qualifications = [
    { degree: beStructure.degree || [] },
    { institute: beStructure.institute || [] },
    { specialization: beStructure.specialization || [] },
  ];

  formData.target_company = beStructure.organization || [];
  formData.location = beStructure.location || [];

  return formData;
};

export const convertStringToInteger = (obj) => {
  // todo : improve this function to handle nested arrays & objects
  const output = { ...obj };
  // eslint-disable-next-line array-callback-return
  Object.keys(obj).map((key) => {
    if (((key !== 'title' && typeof obj[key] === 'string') || (obj[key] instanceof String)) && !Number.isNaN(parseInt(obj[key], 10))) {
      output[key] = parseInt(obj[key], 10);
    }
  });
  return output;
};
export const deConstructSkillsFromPayload = (skillsPayload) => {
  const skillsGroupIdMap = {};
  (skillsPayload ?? []).forEach(({
    skill_group_id: groupId, skill, id, ...restOfSkillDetails
  }) => {
    skillsGroupIdMap[groupId] = {
      ...(skillsGroupIdMap[groupId] || restOfSkillDetails),
      skill: [...(skillsGroupIdMap[groupId]?.skill || []), { name: skill, id }],
      skill_group_id: groupId,
    };
  });
  return Object.values(skillsGroupIdMap ?? {}).map(({ skill, ...rest }) => ({
    ...rest,
    skill: (skill ?? []).map(({ name }) => name)?.join(' or '),
  }));
};
